<template>
  <order-dialog :dialog-visible.sync="computedDialogVisible"
                :top="$isMobile ? '15vh' : '0vh'"
                :pc-width="'40%'"
                custom-class="variable"
                @dialog-close="handleDialogClose"
                v-loading="computedDialogLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.1)">
<!--    content插槽内容-->
    <template #content>
<!--    订单信息（购买的数据库，所需总条数，剩余条数）-->
      <order-dialog-box :title="text[0]" class="db_order_info">
        <template #content>
          <order-info-key-value :key-name="text[1]" :value="companyName"/>
          <el-divider v-if='total||remain'></el-divider>
          <order-info-key-value v-if="total" :key-name="text[2]" :value="total"/>
          <order-info-key-value v-if='remain' :key-name="text[3]" :value="remain"/>
        </template>
      </order-dialog-box>
<!--  购买途径 传入buyMethods 是一个数组 -->
      <order-buy-methods :buy-methods="buyMethods"
                         :pay-disabled="payParams.payDisabled"
                         @pay-click="handlePayClick"
                         @change="setDefaultPayParams"/>
    </template>
    <template #order_code>
      <order-code
          v-loading="qrCodeLoading"
          element-loading-text="二维码生成中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.1)"
          :pay-params="payParams"
          @balance-pay-click="balancePay"></order-code>
    </template>
  </order-dialog>
</template>

<script>
import { Message } from 'element-ui';
import orderDialogMixin from "@/components/OrderDialog/orderDialogMixin";
import OrderBuyMethods from "@/components/OrderDialog/OrderBuyMethods";
import OrderCode from "@/components/OrderDialog/orderCode";
import OrderDialog from "@/components/OrderDialog/OrderDialog";
import OrderDialogBox from "@/components/OrderDialog/OrderDialogBox";
import OrderInfoKeyValue from "@/components/OrderDialog/OrderInfoKeyValue";

import API from "@/../config/api.js";
export default {
  mixins: [orderDialogMixin],
  components: {
    OrderBuyMethods,
    OrderCode,
    OrderDialog,
    OrderDialogBox,
    OrderInfoKeyValue,
  },
  props: {
    companyId: String,
    type: Number,
  },
  mounted() {
    this.getRowAndMonthPayInfo()
  },
  data() {
    return {
		buyMethods: [{
			name: '购买',
			/**
			* 数据库单买价格表*/
			ratios: [],
			type: 0,
			// value 是选中项目在ratios中的索引（方便获取money和value）
			value: undefined,
		}],
		text: ["","","",""],
		companyName: "",
		total: null,
		remain: 0,
    }
  },
  methods: {
		async getRowAndMonthPayInfo() {
			if(this.companyId === undefined)  return
			this.computedDialogLoading = true
			let res = await this.$axiosRequest({
        url: API.getCompanyInfoById,
        method: "GET",
        data: {
          companyId: this.companyId
        }
      })
      res = res[1].data;
      console.log(res);
			res = res.companyInfo;

			let data = await this.$axiosRequest({
        url: API.getBuyInfo,
        method: "GET",
        data: {
          companyId: this.companyId
        }});
      data = data[1].data;
			this.companyName = res.companyName;
			this.buyMethods[0].ratios = []
			this.buyMethods[0].type = this.type;
			if(this.type == 0){
				this.text=["购买变量","公司名称","变量总数","剩余变量"];
				this.total = res.VariableCount;
				for(let i = 1; i <= 3; i++) {
					this.buyMethods[0].ratios.push({
						value: i - 1,
						count: data["Variable_Count" + i],
						label: data["Variable_Count" + i] + "个变量",
						money: data["Variable_Money" + i]
					})
				}
			}else if(this.type==1){
				this.text=["年费购买","公司名称","有效日期",""];
				this.total = res.overdue_date;
				for(let i = 1; i <= 3; i++) {
					this.buyMethods[0].ratios.push({
						value: i - 1,
						count: i,
						label: i + "年",
						money: data["payment_y" + i]
					})
				}
			}else if(this.type==2){
				this.text=["购买历史值","公司名称","历史值总数","剩余变量"];
				this.total = res.VariableValueCount;
				for(let i = 1; i <= 3; i++) {
					this.buyMethods[0].ratios.push({
						value: i - 1,
						count: data["VariableValue_Count" + i],
						label: data["VariableValue_Count" + i] + "个",
						money: data["VariableValue_Money" + i]
					})
				}
			}else if(this.type==3){
				this.text=["购买短信个数","公司名称","短信总数","剩余短信数"];
				this.total = res.VariableValueCount;
				for(let i = 1; i <= 3; i++) {
					this.buyMethods[0].ratios.push({
						value: i - 1,
						count: data["Mes_Count" + i],
						label: data["Mes_Count" + i] + "个",
						money: data["Mes_Money" + i]
					})
				}
			}
			this.computedDialogLoading = false
    },
    beforePayClick() {
		if(this.buyMethods[0].value == undefined){
      Message({
        type: 'warning',
        message: '请选择要购买的项目'
      });
			return false
		}
		return true
    },
  },
  computed: {
    params() {
		let params = {
			companyId: this.companyId,
			type: this.type
		}
		let idx = this.buyMethods[0].value
		params.chargeCount = this.buyMethods[0].ratios[idx].count;
		params.money = this.buyMethods[0].ratios[idx].money;
		return params
    },

  },
  watch: {
    type() {
		this.buyMethods[0].type = this.type
		this.getRowAndMonthPayInfo()
    }
  }
}
</script>

<style scoped>

</style>